import { Pagination, Select, Table } from "antd";
import { useAccountStore, useAuthStore, useRevenueOverall } from "../../store";
import { getStartEndOfAnyMonth } from "../../helper";
import { useEffect, useRef, useState } from "react";
import { useGetFrameAnalysticApi } from "../../hooks/frame/useGetFrameAnalysticApi";
import { EFRAME_SIZE } from "../../ultils/constants";
import { bigSize, freeSize, fullSize, uploadFrame } from "../../assets";
import { FooterFilterMobile } from "../../components";
import { useGetTotalTakePictureOfFrameApi } from "../../hooks/frame/useGetTotalTakePictureOfFrameApi";
import MoonLoader from "react-spinners/MoonLoader";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";

const listMonth = [
  { value: 1, label: "January (1)" },
  { value: 2, label: "February (2)" },
  { value: 3, label: "March (3)" },
  { value: 4, label: "April (4)" },
  { value: 5, label: "May (5)" },
  { value: 6, label: "June (6)" },
  { value: 7, label: "July (7)" },
  { value: 8, label: "August (8)" },
  { value: 9, label: "September (9)" },
  { value: 10, label: "October (10)" },
  { value: 11, label: "November (11)" },
  { value: 12, label: "December (12)" },
];

const FrameAnalysticPage = () => {
  const [listTotalTakePicture, setListTotalTakePicture] = useState<any>();
  const [currentPage, setCurrentPage] = useState(1);
  const [active, setActive] = useState(true);
  const [searchText, setSearchText] = useState("");
  const currentDate = new Date();
  const monthCurrent = currentDate.getMonth() + 1;

  const { token } = useAuthStore();

  const yearCurrent = currentDate.getFullYear() - 1;

  const { info } = useAccountStore();
  const topElement: any = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  const {
    setEndDate,
    setStartDate,
    setYearSelect,
    setMonthSelect,
    monthSelect,
    startDate,
    endDate,
  } = useRevenueOverall();

  const { end: endDayOfMonth, start: startDayOfMonth } = getStartEndOfAnyMonth(
    yearCurrent,
    monthSelect ?? monthCurrent
  );

  useEffect(() => {
    setStartDate(startDayOfMonth);
    setEndDate(endDayOfMonth);
    setYearSelect(yearCurrent);
    setMonthSelect(monthSelect ? monthSelect : monthCurrent);
  }, [yearCurrent, monthCurrent, startDayOfMonth, endDayOfMonth]);

  // api
  const { frameAnalystic } = useGetFrameAnalysticApi({
    accountId: info?.id,
    startDate,
    endDate,
  });

  const { totalTakePictureOfFrame, isLoading } =
    useGetTotalTakePictureOfFrameApi({
      active,
      startDate,
      endDate,
    });

  // pagination
  const itemInPerPage = 5;

  const indexOfLastItem = currentPage * itemInPerPage;
  const indexOfFirstItem = indexOfLastItem - itemInPerPage;

  useEffect(() => {
    const currentItems = totalTakePictureOfFrame?.data?.data?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
    if (currentItems) {
      setListTotalTakePicture(currentItems);
    }
  }, [currentPage, totalTakePictureOfFrame]);

  const filteredData = listTotalTakePicture?.filter(
    (item: any) =>
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.index.toString().includes(searchText)
  );

  const columns = [
    {
      title: "name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "color",
      dataIndex: "color",
      key: "color",
    },
    {
      title: "price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "thumnail",
      dataIndex: "thumnail",
      key: "thumnail",
      render: (item: any) => {
        return (
          <img
            className="xl:w-24 w-20"
            src={item?.replace(
              "http://27.71.26.120",
              "https://phototimevn.com"
            )}
          ></img>
        );
      },
    },
    {
      title: "FRAME IMAGE",
      dataIndex: "url",
      key: "url",
      render: (item: any) => {
        return (
          <img
            className="xl:w-24 w-20"
            src={item?.replace(
              "http://27.71.26.120",
              "https://phototimevn.com"
            )}
          ></img>
        );
      },
    },
    {
      title: "typeFrame",
      dataIndex: "typeFrame",
      key: "typeFrame",
    },
    {
      title: "resultTotal",
      dataIndex: "resultTotal",
      key: "resultTotal",
      render: (item: any) => {
        return <span className="font-bold">{item}</span>;
      },
    },
  ];

  return (
    <div className="flex flex-col xl:gap-4 lg:gap-3 gap-2 max-md:px-[16px]">
      <div className="flex justify-between max-md:mt-4">
        <div>
          <Select
            defaultValue={monthSelect ? monthSelect : monthCurrent}
            style={{ width: 140 }}
            allowClear
            onChange={(e) => {
              setMonthSelect(e);
            }}
            options={listMonth}
            placeholder="select it"
          />
        </div>
      </div>
      <div className="grid xl:grid-cols-4 grid-cols-2 xl:gap-8 lg:gap-6 gap-4">
        {frameAnalystic &&
          frameAnalystic?.data?.data?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="flex items-center justify-center xl:p-[16px] lg:p-[12px] p-[8px] flex-col xl:gap-2 gap-1 bg-white shadow rounded-md xl:min-h-[16vh]"
              >
                <img
                  className="2xl:w-36 xl:w-32 lg:w-28 w-24"
                  src={
                    item?.nameFrame === EFRAME_SIZE.FRAME_4B2
                      ? bigSize
                      : item?.nameFrame === EFRAME_SIZE.FRAME_B4
                      ? fullSize
                      : item?.nameFrame === EFRAME_SIZE.FRAME_4
                      ? freeSize
                      : uploadFrame
                  }
                ></img>
                <span className="font-bold 2xl:text-3xl xl:text-2xl text-xl text-gray-600">
                  {item?.totalRecord}
                </span>
              </div>
            );
          })}
      </div>
      <div className="xl:mt-6 mt-4 h-full">
        {isLoading ? (
          <div className="h-full w-full flex justify-center items-center mt-10 flex-col gap-2">
            <MoonLoader
              loading={isLoading}
              color="#D12E93"
              speedMultiplier={0.5}
            />
            <span className="font-medium mt-2 text-photo-time-pink-main">
              Loading...
            </span>
          </div>
        ) : (
          <div ref={topElement} className="w-full flex flex-col xl:gap-3 gap-2">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center max-md:flex-col xl:gap-3 gap-2">
                <span className="uppercase font-semibold xl:text-xl text-base max-sm:text-sm text-gray-700">
                  frame count statistics
                </span>
                <div className="flex items-center xl:gap-3 gap-2">
                  <div
                    onClick={() => setActive(true)}
                    className={`xl:py-[4px] xl:px-[12px] py-[3px] px-[12px] flex items-center justify-center rounded-2xl font-semibold cursor-pointer ${
                      active === true
                        ? "bg-photo-time-pink-main text-white"
                        : "border-[1px] border-gray-500"
                    }`}
                  >
                    <span className="text-sm">ACTIVE</span>
                  </div>
                  <div
                    onClick={() => setActive(false)}
                    className={`xl:py-[4px] xl:px-[12px] py-[3px] px-[12px] flex items-center justify-center rounded-2xl font-semibold cursor-pointer ${
                      active === false
                        ? "bg-photo-time-pink-main text-white"
                        : "border-[1px] border-gray-500"
                    }`}
                  >
                    <span className="text-sm">NO-ACTIVE</span>
                  </div>
                </div>
              </div>
              <div className="max-md:hidden">
                <input
                  type="text"
                  placeholder="Find by name or index"
                  className="border p-1 rounded-md outline-none placeholder:text-sm xl:w-[12vw]"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            <Table
              className="max-md:hidden"
              dataSource={filteredData}
              columns={columns}
              pagination={false}
            ></Table>
            <div className="md:hidden w-full flex flex-col max-md:gap-5 gap-4">
              {filteredData?.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="flex flex-col w-full bg-white border-[1px] border-gray-200 sm:min-h-[20vh] max-sm:min-h-[20vh]"
                  >
                    <div className="w-full sm:h-[10vh] max-sm:h-[8vh] bg-gray-200 flex items-center justify-between sm:p-[12px] p-[10px]">
                      <div className="flex items-center gap-3">
                        <img
                          className="max-sm:w-10 sm:w-12"
                          src={item?.thumnail}
                        ></img>
                        <span className="uppercase font-semibold text-gray-600">
                          {item?.name}
                        </span>
                      </div>
                    </div>
                    <div className="sm:p-[12px] p-[10px] w-full h-auto flex flex-col sm:gap-5 max-sm:gap-4">
                      <div className="flex items-center sm:gap-6 gap-5">
                        <div className="w-[30%] font-bold text-gray-600">
                          typeFrame:
                        </div>
                        <div className="uppercase text-gray-700 font-semibold">
                          {item?.typeFrame}
                        </div>
                      </div>
                      <div className="flex items-center sm:gap-6 gap-5">
                        <div className="w-[30%] font-bold text-gray-600">
                          index:
                        </div>
                        <div className="uppercase text-gray-700">
                          {item?.index}
                        </div>
                      </div>
                      <div className="flex items-center sm:gap-6 gap-5">
                        <div className="w-[30%] font-bold text-gray-600">
                          price:
                        </div>
                        <div className="uppercase text-gray-700">
                          {item?.price}
                        </div>
                      </div>
                      <div className="flex items-center sm:gap-6 gap-5">
                        <div className="w-[30%] font-bold text-gray-600">
                          resultTotal:
                        </div>
                        <div className="uppercase text-photo-time-pink-main font-bold">
                          {item?.resultTotal}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <Pagination
              current={currentPage}
              total={totalTakePictureOfFrame?.data?.data?.length}
              pageSize={itemInPerPage}
              onChange={(page) => {
                setCurrentPage(page);
                topElement.current.scrollIntoView({ behavior: "smooth" });
              }}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>
      {/* <FooterMobile></FooterMobile> */}
      <FooterFilterMobile isFilter={true}></FooterFilterMobile>
    </div>
  );
};

export default FrameAnalysticPage;
